import React, { useEffect, useState } from "react";
import Content from "../../Components/Core/Content";
import PersianDatePicker from "../../Components/Core/DatePicker";
import { getSuccesPayments } from "../../Services/ReservationService";
import Loader from "../../Components/Core/Loader";
import {
  Button,
  Pagination,
  Chip,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import { faSearch, faRotateRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Notification from "../../Components/Core/Notification";

const SuccessPayments = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(15);
  const [totalItems, setTotalItems] = useState(0);
  const [hasActiveFilters, setHasActiveFilters] = useState(false);

  // Filters
  const [fromDate, setFromDate] = useState(
    new Date(new Date().setMonth(new Date().getMonth() - 1)),
  );
  const [toDate, setToDate] = useState(new Date());
  const [mobileNumber, setMobileNumber] = useState("");
  const [name, setName] = useState("");
  const [transactionType, setTransactionType] = useState("");
  const [refId, setRefId] = useState("");

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const fetchData = async (page = 1) => {
    try {
      setLoading(true);
      const fromDateTime = new Date(fromDate);
      fromDateTime.setHours(0, 0, 0, 0);

      const toDateTime = new Date(toDate);
      toDateTime.setHours(23, 59, 59, 999);

      const filter = {
        fromDate: fromDateTime.toISOString(),
        toDate: toDateTime.toISOString(),
        mobileNumber: mobileNumber.trim(),
        name: name.trim(),
        transactionType:
          transactionType === "Reservation"
            ? 1
            : transactionType === "Consultation"
              ? 2
              : null,
        refId: refId.trim(),
        page,
        pageSize: itemsPerPage,
      };
      const response = await getSuccesPayments(filter);
      setPayments(response.items || response);
      setTotalItems(response.totalCount || response.length);
      setCurrentPage(page);

      setHasActiveFilters(
        mobileNumber.trim() || name.trim() || transactionType || refId.trim(),
      );
    } catch (error) {
      console.log(error.message);
      setSnackbarMessage("خطا در دریافت تراکنش‌ها");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    fetchData(1);
  };

  const handleReset = () => {
    setMobileNumber("");
    setName("");
    setTransactionType("");
    setRefId("");
    setFromDate(new Date(new Date().setMonth(new Date().getMonth() - 1)));
    setToDate(new Date());
    setHasActiveFilters(false);
    fetchData(1);
  };

  const handlePageChange = (event, value) => {
    fetchData(value);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  useEffect(() => {
    document.title = "مدیریت تراکنش‌ها";
    fetchData(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Content>
      <div className="container color-blue mb-5">
        {/* Header */}
        <h2 className="mb-4 row mt-5 highlight-box highlight-secondary fw-bold color-blue">
          <span>مدیریت تراکنش‌ها</span>
        </h2>

        {/* Filters */}
        <div className="row mt-4">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-body p-3 p-md-4">
                {/* Desktop */}
                <div className="d-none d-md-block">
                  <div className="row g-3">
                    <div className="col-md-2">
                      <PersianDatePicker
                        name="از تاریخ"
                        value={fromDate}
                        onChange={setFromDate}
                      />
                    </div>

                    <div className="col-md-2">
                      <PersianDatePicker
                        name="تا تاریخ"
                        value={toDate}
                        onChange={setToDate}
                      />
                    </div>

                    <div className="col-md-2">
                      <label
                        className="form-label iran-sans mb-1"
                        style={{ fontSize: "14px" }}
                      >
                        نام کاربر
                      </label>
                      <input
                        className="form-control form-blue iran-sans"
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="نام"
                        style={{ height: "37px" }}
                      />
                    </div>

                    <div className="col-md-2">
                      <label
                        className="form-label iran-sans mb-1"
                        style={{ fontSize: "14px" }}
                      >
                        موبایل
                      </label>
                      <input
                        className="form-control form-blue iran-sans"
                        type="tel"
                        value={mobileNumber}
                        onChange={(e) => setMobileNumber(e.target.value)}
                        placeholder="09123456789"
                        dir="ltr"
                        style={{ height: "37px" }}
                      />
                    </div>

                    <div className="col-md-2">
                      <label
                        className="form-label iran-sans mb-1"
                        style={{ fontSize: "14px" }}
                      >
                        بابت
                      </label>
                      <FormControl fullWidth>
                        <Select
                          value={transactionType}
                          onChange={(e) => setTransactionType(e.target.value)}
                          displayEmpty
                          sx={{
                            height: "37px",
                            fontFamily: "iran-sans",
                            "& .MuiSelect-select": {
                              fontFamily: "iran-sans",
                            },
                          }}
                        >
                          <MenuItem value="">همه</MenuItem>
                          <MenuItem value="Reservation">رزرو</MenuItem>
                          <MenuItem value="Consultation">مشاوره</MenuItem>
                        </Select>
                      </FormControl>
                    </div>

                    <div className="col-md-2">
                      <label
                        className="form-label iran-sans mb-1"
                        style={{ fontSize: "14px" }}
                      >
                        شماره پیگیری
                      </label>
                      <input
                        className="form-control form-blue iran-sans"
                        type="text"
                        value={refId}
                        onChange={(e) => setRefId(e.target.value)}
                        placeholder="شماره پیگیری"
                        dir="ltr"
                        style={{ height: "37px" }}
                      />
                    </div>
                  </div>

                  <div className="row mt-3">
                    <div className="col-12 d-flex gap-2">
                      <Button
                        variant="contained"
                        className="btn-blue"
                        onClick={handleSearch}
                        style={{ height: "38px" }}
                      >
                        <FontAwesomeIcon icon={faSearch} className="me-2" />
                        <span>جستجو</span>
                      </Button>

                      {hasActiveFilters && (
                        <Button
                          variant="outlined"
                          onClick={handleReset}
                          style={{
                            height: "38px",
                            border: "1px solid #e9ecef",
                            color: "#053251",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faRotateRight}
                            className="me-2"
                          />
                          <span>پاک کردن</span>
                        </Button>
                      )}
                    </div>
                  </div>
                </div>

                {/* Mobile */}
                <div className="d-md-none">
                  <div className="row g-2">
                    <div className="col-6">
                      <label
                        className="form-label iran-sans mb-1"
                        style={{ fontSize: "12px" }}
                      >
                        از تاریخ
                      </label>
                      <PersianDatePicker
                        value={fromDate}
                        onChange={setFromDate}
                        placeholder="از تاریخ"
                      />
                    </div>

                    <div className="col-6">
                      <label
                        className="form-label iran-sans mb-1"
                        style={{ fontSize: "12px" }}
                      >
                        تا تاریخ
                      </label>
                      <PersianDatePicker
                        value={toDate}
                        onChange={setToDate}
                        placeholder="تا تاریخ"
                      />
                    </div>

                    <div className="col-12">
                      <input
                        className="form-control form-blue iran-sans"
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="نام کاربر"
                        style={{ height: "38px", fontSize: "14px" }}
                      />
                    </div>

                    <div className="col-6">
                      <input
                        className="form-control form-blue iran-sans"
                        type="tel"
                        value={mobileNumber}
                        onChange={(e) => setMobileNumber(e.target.value)}
                        placeholder="موبایل"
                        dir="ltr"
                        style={{ height: "38px", fontSize: "14px" }}
                      />
                    </div>

                    <div className="col-6">
                      <FormControl fullWidth>
                        <Select
                          value={transactionType}
                          onChange={(e) => setTransactionType(e.target.value)}
                          displayEmpty
                          sx={{
                            height: "38px",
                            fontSize: "14px",
                            fontFamily: "iran-sans, MyPersianFont, sans-serif",
                          }}
                        >
                          <MenuItem value="">بابت: همه</MenuItem>
                          <MenuItem value="Reservation">رزرو</MenuItem>
                          <MenuItem value="Consultation">مشاوره</MenuItem>
                        </Select>
                      </FormControl>
                    </div>

                    <div className="col-12">
                      <input
                        className="form-control form-blue iran-sans"
                        type="text"
                        value={refId}
                        onChange={(e) => setRefId(e.target.value)}
                        placeholder="شماره پیگیری"
                        dir="ltr"
                        style={{ height: "38px", fontSize: "14px" }}
                      />
                    </div>

                    <div className="col-12 d-flex gap-2 mt-2">
                      <Button
                        variant="contained"
                        className="btn-blue flex-grow-1"
                        onClick={handleSearch}
                        style={{ height: "38px" }}
                      >
                        <FontAwesomeIcon icon={faSearch} className="me-2" />
                        <span>جستجو</span>
                      </Button>

                      {hasActiveFilters && (
                        <Button
                          variant="outlined"
                          onClick={handleReset}
                          style={{
                            height: "38px",
                            minWidth: "38px",
                            padding: "0 12px",
                            border: "1px solid #e9ecef",
                            color: "#053251",
                          }}
                        >
                          <FontAwesomeIcon icon={faRotateRight} size="sm" />
                        </Button>
                      )}
                    </div>
                  </div>
                </div>

                {/* Active Filters */}
                {hasActiveFilters && (
                  <div className="mt-3 d-flex align-items-center gap-2 flex-wrap">
                    {name && (
                      <Chip
                        label={name}
                        onDelete={() => setName("")}
                        size="small"
                        sx={{
                          backgroundColor: "#e8f5e9",
                          color: "#053251",
                          fontFamily: "iran-sans",
                          fontSize: "12px",
                          height: "24px",
                        }}
                      />
                    )}
                    {mobileNumber && (
                      <Chip
                        label={mobileNumber}
                        onDelete={() => setMobileNumber("")}
                        size="small"
                        sx={{
                          backgroundColor: "#e8f5e9",
                          color: "#053251",
                          fontFamily: "iran-sans",
                          fontSize: "12px",
                          height: "24px",
                        }}
                      />
                    )}
                    {transactionType && (
                      <Chip
                        label={
                          transactionType === "Reservation" ? "رزرو" : "مشاوره"
                        }
                        onDelete={() => setTransactionType("")}
                        size="small"
                        className="iran-sans"
                        sx={{
                          backgroundColor: "#e8f5e9",
                          color: "#053251",
                          fontSize: "12px",
                          height: "24px",
                          fontFamily: "iran-sans, MyPersianFont, sans-serif",
                        }}
                      />
                    )}
                    {refId && (
                      <Chip
                        label={refId}
                        onDelete={() => setRefId("")}
                        size="small"
                        sx={{
                          backgroundColor: "#e8f5e9",
                          color: "#053251",
                          fontFamily: "iran-sans",
                          fontSize: "12px",
                          height: "24px",
                        }}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Summary Card */}
        {!loading && payments.length > 0 && (
          <div className="row mt-3">
            <div className="col-12">
              <div
                className="card border-0 shadow-sm"
                style={{
                  background:
                    "linear-gradient(135deg, #7cc890 0%, #6ab77d 100%)",
                  color: "white",
                }}
              ></div>
            </div>
          </div>
        )}

        {/* Results Info */}
        {!loading && payments.length > 0 && (
          <div className="row mt-3">
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-center">
                <span
                  className="iran-sans"
                  style={{ fontSize: "14px", color: "#6c757d" }}
                >
                  تعداد کل: {totalItems} تراکنش
                </span>
                <span
                  className="iran-sans"
                  style={{ fontSize: "14px", color: "#6c757d" }}
                >
                  صفحه {currentPage} از {totalPages || 1}
                </span>
              </div>
            </div>
          </div>
        )}

        {/* Results */}
        {loading ? (
          <Loader />
        ) : payments.length === 0 ? (
          <div className="row mt-4">
            <div className="col-12">
              <div
                className="card border-0 shadow-sm text-center py-5"
                style={{
                  background:
                    "linear-gradient(135deg, rgba(124, 200, 144, 0.05) 0%, rgba(5, 50, 81, 0.02) 100%)",
                }}
              >
                <div className="card-body">
                  <div style={{ fontSize: "48px", marginBottom: "16px" }}>
                    💳
                  </div>
                  <h5 className="iran-sans fw-bold color-blue">
                    تراکنشی یافت نشد
                  </h5>
                  <p className="iran-sans text-muted">
                    {hasActiveFilters
                      ? "با فیلترهای انتخابی، تراکنشی یافت نشد"
                      : "در بازه زمانی انتخابی، تراکنشی ثبت نشده است"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            {/* Desktop Table */}
            <div className="row mt-4 d-none d-lg-block">
              <div className="col-12">
                <div className="card border-0 shadow-sm">
                  <div className="table-responsive">
                    <table className="table table-hover mb-0 iran-sans">
                      <thead
                        style={{
                          background:
                            "linear-gradient(135deg, #053251 0%, #2a5a72 100%)",
                          color: "white",
                        }}
                      >
                        <tr>
                          <th className="p-3">بابت</th>
                          <th className="p-3">نام</th>
                          <th className="p-3">موبایل</th>
                          <th className="p-3">تاریخ پرداخت</th>
                          <th className="p-3">تاریخ رزرو</th>
                          <th className="p-3">ساعت</th>
                          <th className="p-3">مبلغ</th>
                          <th className="p-3">شماره پیگیری</th>
                          <th className="p-3">کارت</th>
                        </tr>
                      </thead>
                      <tbody>
                        {payments.map((payment) => (
                          <tr key={payment.id}>
                            <td className="p-3">
                              <span
                                className="badge"
                                style={{
                                  background:
                                    payment.transactionTypeName === "رزرو"
                                      ? "#7cc890"
                                      : "#053251",
                                  color: "white",
                                }}
                              >
                                {payment.transactionTypeName}
                              </span>
                            </td>
                            <td className="p-3 fw-bold">{payment.userName}</td>
                            <td className="p-3" dir="ltr">
                              {payment.userMobileNumber}
                            </td>
                            <td className="p-3">{payment.payDateDisplay}</td>
                            <td className="p-3">{payment.date || "—"}</td>
                            <td className="p-3">{payment.startTime || "—"}</td>
                            <td
                              className="p-3 fw-bold"
                              style={{ color: "#7cc890" }}
                            >
                              {payment.amount?.toLocaleString()} ت
                            </td>
                            <td className="p-3" dir="ltr">
                              <small>{payment.refId}</small>
                            </td>
                            <td className="p-3" dir="ltr">
                              <small>{payment.cardPan || "—"}</small>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            {/* Mobile Cards */}
            <div className="row mt-4 d-lg-none">
              {payments.map((payment) => (
                <div key={payment.id} className="col-12 mb-3">
                  <div
                    className="card border-0 shadow-sm"
                    style={{
                      borderRadius: "16px",
                      overflow: "hidden",
                      borderTop:
                        payment.transactionTypeName === "رزرو"
                          ? "4px solid #7cc890"
                          : "4px solid #053251",
                    }}
                  >
                    <div
                      style={{
                        background:
                          payment.transactionTypeName === "رزرو"
                            ? "linear-gradient(135deg, #7cc890 0%, #6bb57f 100%)"
                            : "linear-gradient(135deg, #053251 0%, #2a5a72 100%)",
                        padding: "12px 16px",
                        color: "white",
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <span className="iran-sans fw-bold">
                            {payment.userName}
                          </span>
                          <div
                            className="iran-sans"
                            style={{ fontSize: "12px", marginTop: "4px" }}
                          >
                            {payment.transactionTypeName}
                          </div>
                        </div>
                        <div style={{ fontSize: "18px", fontWeight: "700" }}>
                          {payment.amount?.toLocaleString()} ${" "}
                        </div>
                      </div>
                    </div>

                    <div className="card-body p-3">
                      <div className="iran-sans" style={{ fontSize: "14px" }}>
                        <div className="mb-2 d-flex justify-content-between">
                          <strong>تاریخ پرداخت:</strong>
                          <span>{payment.payDateDisplay}</span>
                        </div>
                        {payment.date && (
                          <div className="mb-2 d-flex justify-content-between">
                            <strong>تاریخ رزرو:</strong>
                            <span>
                              {payment.date}
                              {payment.startTime && ` - ${payment.startTime}`}
                            </span>
                          </div>
                        )}
                        <div className="mb-2 d-flex justify-content-between">
                          <strong>موبایل:</strong>
                          <span dir="ltr">{payment.userMobileNumber}</span>
                        </div>
                        <div className="mb-2 d-flex justify-content-between">
                          <strong>شماره پیگیری:</strong>
                          <span dir="ltr" style={{ fontSize: "12px" }}>
                            {payment.refId}
                          </span>
                        </div>
                        {payment.cardPan && (
                          <div className="d-flex justify-content-between">
                            <strong>کارت:</strong>
                            <span dir="ltr" style={{ fontSize: "12px" }}>
                              {payment.cardPan}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="row mt-4 pb-5">
                <div className="col-12 d-flex justify-content-center">
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={handlePageChange}
                    color="primary"
                    size="large"
                    showFirstButton
                    showLastButton
                    sx={{
                      "& .MuiPaginationItem-root": {
                        fontFamily: "MyPersianFont, sans-serif",
                        "&.Mui-selected": {
                          backgroundColor: "#7cc890",
                          color: "white",
                          "&:hover": {
                            backgroundColor: "#6bb57f",
                          },
                        },
                      },
                    }}
                  />
                </div>
              </div>
            )}
          </>
        )}
      </div>

      <Notification
        openSnackbar={openSnackbar}
        snackbarMessage={snackbarMessage}
        snackbarSeverity={snackbarSeverity}
        setOpenSnackbar={setOpenSnackbar}
      />
    </Content>
  );
};

export default SuccessPayments;
